<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__channelcallback}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.id" placeholder="id" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <!-- <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button> -->
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:channelcallback:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:channelcallback:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <!-- <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column> -->
        <el-table-column prop="id" label="id" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="customerId" label="用户id" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="companyId" label="公司ID" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="productId" label="下游产品ID" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="content" label="推送内容" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        
        <el-table-column prop="isPush" label="是否已推送1是0否" header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isPush == 0" type="danger" size="small">否</el-tag>
	          <el-tag v-if="scope.row.isPush == 1" size="small">是</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="respCode" label="推送返回状态码" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="respMsg" label="推送返回信息" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="pushDate" width="180" label="推送时间" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="status" label="状态（1有效、0无效）" header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == 0" type="danger" size="small">无效</el-tag>
	          <el-tag v-if="scope.row.status == 1" size="small">有效</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="类型" header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type == 2" type="danger" size="small">无效</el-tag>
	          <el-tag v-if="scope.row.type == 1" size="small">有效</el-tag>
            <el-tag v-if="scope.row.type == 0" type="warning" size="small">未回访</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="creator" label="创建人" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createDate" width="180" label="创建日期" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="updateBy" label="更新人" header-align="center" align="center"  show-overflow-tooltip></el-table-column>
        <el-table-column prop="updateTime" width="180" label="更新日期" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column prop="deleteTime" label="删除日期" header-align="center" align="center" show-overflow-tooltip></el-table-column> -->
        <el-table-column prop="remark" label="备注" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150" >
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:channelcallback:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:channelcallback:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './channelcallback-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/channelcallback/page',
        getDataListIsPage: true,
        exportURL: '/sys/channelcallback/export',
        deleteURL: '/sys/channelcallback',
        deleteIsBatch: true
      },
      dataForm: {
        id: ''
      }
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
